import {
  Box,
  Button,
  Grid,
} from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";

export const SearchForm = ({ onClickSearchButton, searchCondition , setSearchCondition}) => {

  const handleChangeKeyword = (e) => {
    setSearchCondition({...searchCondition, keyword: e.target.value})
  }

  const handleChangeUpdateDatePeriodStart = (e) => {
    setSearchCondition({...searchCondition, updateDatePeriodStart: e.target.value})
  }

  const handleChangeUpdateDatePeriodEnd = (e) => {
    setSearchCondition({...searchCondition, updateDatePeriodEnd: e.target.value})
  }
  

  return (
    <Box border="1px solid blue" borderRadius={1} padding={2}>
      <Box margin={2} marginBottom={1}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs="auto">
            キーワード　&nbsp;
            <OutlinedInput
              sx={{ width: 250 }}
              value={searchCondition.keyword}
              onChange={handleChangeKeyword}
            />
          </Grid>
        </Grid>

        <Grid item>
          <Box height={35} />
        </Grid>

        <Grid container alignItems="center" spacing={2}>
          <Grid item xs="auto">
            更新日期間　&nbsp;
            <OutlinedInput
              type="date"
              inputProps={{
                min: "1000-01-01",
                max: "9999-12-31",
              }}
              value={searchCondition.updateDatePeriodStart}
              onChange={handleChangeUpdateDatePeriodStart}
            />
            &nbsp;～&nbsp;
            <OutlinedInput
              type="date"
              inputProps={{
                min: "1000-01-01",
                max: "9999-12-31",
              }}
              value={searchCondition.updateDatePeriodEnd}
              onChange={handleChangeUpdateDatePeriodEnd}
            />
          </Grid>
        </Grid>

        <Grid
          container
          alignItems="center"
          justifyContent="flex-end"
          spacing={1}
        >
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={onClickSearchButton}
            >
              検索
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
